import { createLayerCanvas, drawPointsPath, toDataUrl } from './canvasUtils'
import { extractLandmarkFeatures } from './extractLandmarkFeatures'

export const buildMeshContoursLayer = ({
  landmarks,
  width,
  height,
  features = null
}) => {
  if (!landmarks?.length) return null
  const featureMap = features || extractLandmarkFeatures({ landmarks, width, height })
  if (!featureMap?.paths) return null
  const { canvas, ctx } = createLayerCanvas(width, height)
  ctx.lineCap = 'round'
  ctx.lineJoin = 'round'

  drawPointsPath(ctx, featureMap.paths.faceOval, {
    close: true,
    stroke: 'rgba(148, 163, 184, 0.95)',
    lineWidth: 1.5
  })
  drawPointsPath(ctx, featureMap.paths.leftEye, {
    close: true,
    stroke: 'rgba(147, 197, 253, 0.95)',
    lineWidth: 1.2
  })
  drawPointsPath(ctx, featureMap.paths.rightEye, {
    close: true,
    stroke: 'rgba(147, 197, 253, 0.95)',
    lineWidth: 1.2
  })
  drawPointsPath(ctx, featureMap.paths.leftBrow, {
    close: false,
    stroke: 'rgba(125, 211, 252, 0.95)',
    lineWidth: 1.2
  })
  drawPointsPath(ctx, featureMap.paths.rightBrow, {
    close: false,
    stroke: 'rgba(125, 211, 252, 0.95)',
    lineWidth: 1.2
  })
  drawPointsPath(ctx, featureMap.paths.noseBridge, {
    close: false,
    stroke: 'rgba(56, 189, 248, 0.95)',
    lineWidth: 1.2
  })
  drawPointsPath(ctx, featureMap.paths.lipsOuter, {
    close: true,
    stroke: 'rgba(251, 113, 133, 0.95)',
    lineWidth: 1.2
  })
  drawPointsPath(ctx, featureMap.paths.lipsInner, {
    close: true,
    stroke: 'rgba(252, 165, 165, 0.95)',
    lineWidth: 1.1
  })

  return toDataUrl(canvas)
}
